import { Tab, TabsHeader } from 'components/Tabs'
import { Link, navigate } from 'gatsby'
import useNestedDocuments from 'hooks/useNestedDocuments'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { getLocalStorage } from 'utils/getLocalStorage'

export const ContentSwitcherStickyWrapper = styled.div`
	position: relative;
`

export const ContentSwitcherStickyContainer = styled.div`
	margin-top: 16px;
	margin-bottom: 32px;

	position: sticky;
	z-index: 1000;
	top: 64px;
	padding-top: 16px;
	background: white;
`

export const RawContentSwitcher = ({ links, currentId, onClick }) => (
	<TabsHeader variant='underline' noPadding>
		{links
			.map(link => (
				<Tab
					as={Link}
					to={link.url}
					key={link.id}
					title={link.label}
					id={link.id}
					active={link.id === currentId}
					onClick={e => {
						e.preventDefault()
						onClick?.(link, e)
					}}
				/>
			))
			.filter(Boolean)}
	</TabsHeader>
)

export default function ContentSwitcher({ parentLocation, location, stretch = false }) {
	const nested = useNestedDocuments(parentLocation?.pathname, { withoutParent: true })
	const locationParts = location.pathname.split('/')

	const currentId = location.pathname.endsWith('/')
		? locationParts[locationParts.length - 2]
		: locationParts[locationParts.length - 1]

	const links = useMemo(
		() =>
			nested.map((link, index) => ({
				url: link.url,
				id: link.switcherData?.id,
				label: link.switcherData?.label,
				index,
			})),
		[nested],
	)

	if (!links.length) return null

	return (
		<RawContentSwitcher
			stretch={stretch}
			links={links}
			currentId={currentId}
			onClick={link => {
				const { switcherData } = nested[link.index] ?? {}
				getLocalStorage().setItem(switcherData?.uses, switcherData?.id)
				navigate(link.url, { state: { disableScrollUpdate: true } })
			}}
		/>
	)
}
